import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Spinner } from '@deerplusofficial/pos-components';

const SpinnerWrapper = styled.div`
  margin: 60px auto;
  text-align: center;
`;

export default class Dimmer extends React.PureComponent {
  static propTypes = {
    dark: PropTypes.bool,
  };

  static defaultProps = {
    dark: false,
  };

  render() {
    const { dark } = this.props;

    return (
      <SpinnerWrapper>
        <Spinner dark={dark} />
      </SpinnerWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Dimmer/Dimmer.js